import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// FontAwesome
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Config
import styles from "../../config/styles";

// Hooks
import useTranslate from "../../hooks/useTranslate";

// Components
import CustomField from "../../components/CustomField";
import Switch from "../../components/Switch";
import Text from "../../components/Text";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 3)
  },
  titleWrapper: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1)
  },
  title: {
    margin: "0"
  },
  switch: {
    margin: 0
  },
  inputWrapper: {
    position: "relative"
  },
  input: {
    ...styles.mixins.input,
    backgroundColor: "#F7F7FA"
  },
  checkIcon: {
    position: "absolute",
    right: 20,
    bottom: 38,
    zIndex: 88,
    color: "#3AE161"
  }
}));

const CrimeReferenceSubmit = ({ disabled, disableSwitch }) => {
  const classes = useStyles();
  const getText = useTranslate();

  const fieldProps = disableSwitch
    ? {
        InputProps: {
          classes: { input: classes.input }
        }
      }
    : {};

  return (
    <Paper elevation={0} className={classes.root}>
      <div className={classes.contentContainer}>
        <div className={classes.titleWrapper}>
          <Text
            className={classes.title}
            text="createCasePage.formContent.crimeReferenceTitle"
            type="heading4"
          />
          {!disableSwitch && (
            <Field
              name="isReported"
              component={Switch}
              isFormik
              className={classes.switch}
              disabled={disableSwitch}
            />
          )}
        </div>
        <div className={classes.inputWrapper}>
          <CustomField
            autoComplete="off"
            disabled={disabled}
            label={getText("createCasePage.formContent.crimeReferenceLabel")}
            name="crimeReferenceNumber"
            placeholder={getText(
              "createCasePage.formContent.crimeReferencePlaceholder"
            )}
            {...fieldProps}
          />
          {disableSwitch && (
            <FontAwesomeIcon className={classes.checkIcon} icon={faCheck} />
          )}
        </div>
      </div>
    </Paper>
  );
};

CrimeReferenceSubmit.propTypes = {
  disabled: PropTypes.bool.isRequired,
  disableSwitch: PropTypes.bool.isRequired
};

export default CrimeReferenceSubmit;
